
<div *ngIf="isLoggedIn" class="loggin-user" (click)="menu.toggle($event)">
    <i class="pi pi-user"></i>
    <span>Welcome, {{userFullName}}!</span>
</div>
<button pButton pRipple type="button" label="Login" class="p-button-text text-white font-bold" (click)="onLoginClicked()" *ngIf="!isLoggedIn"></button>
<i class="pi pi-sign-in text-white" style="font-size: 1rem;vertical-align: super;margin-left: -10px;" (click)="onLoginClicked()" *ngIf="!isLoggedIn"></i>

<p-menu #menu [popup]="true" [model]="items"></p-menu>
